import http from '@/util/http';

export default {
    verifyAuth(model) {
		return postWithBidToken('Bid/api/verifyAuth', model);
    },
    verifyToken(mdn, quickPayToken){
		return getWithBidToken('Bid/api/verifyToken', { params: { mdn, quickPayToken } });
	},
    getBidHappyPackage(mdn, setId) {
        return getWithBidToken('Bid/api/getBidHappyPackage', { params: { mdn, token, setId} });
    },
    getCaptchaCode() {
        return getWithBidToken('Bid/api/getCaptchaCode');
    },
	changeSetServiceStatus(mdn, setId, applyStatus) {
		return getWithBidToken('Bid/api/changeSetServiceStatus', { params: { mdn, token, setId, applyStatus } });
    }
}
function getWithBidToken(url, obj) {
    let objWithHeader = Object.assign(obj || {}, {headers: {'token': ( window.sessionStorage.bidToken || '' ) + 'MDN=' + ( window.sessionStorage.bidMdn || '')}})
    return http.get(url, objWithHeader);
}
function postWithBidToken(url, params, obj) {
    let objWithHeader = Object.assign(obj || {}, {headers: {'token': ( window.sessionStorage.bidToken || '' ) + 'MDN=' + ( window.sessionStorage.bidMdn || '')}})
    return http.post(url, params, objWithHeader);
}


// WEBPACK FOOTER //
// ./src/api/bid/bidApi.js